





































































































































































































// @ts-ignore
import v8n from 'v8n';
// @ts-ignore
import draggable from 'vuedraggable';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Auction, Lot, Bid, ApiError, Media, User } from '@/api';
import { snackModule } from '@/store';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import MediaUpload from '@/components/admin/MediaUpload.vue';
import BidEdit from '@/components/admin/BidEdit.vue';

@Component({
  components: { draggable, AbstractTable, ConfirmDialog, MediaUpload, BidEdit },
})
export default class extends Vue {
  @Prop({ required: true }) readonly auctionId: number;
  @Prop({ required: false }) readonly selectedLot: Lot;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  auction: Auction | null = null;

  lot: Lot | null = null;

  mediaToDelete: Media[] = [];

  bidDialog: boolean = false;
  bidToEdit: Bid | null = null;
  selected: Bid[] = [];
  bidConfirmDialog: boolean = false;

  closeConfirmDialog: boolean = false;

  salePrice = '$0';

  requiredRule = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  get lotId() {
    return this.selectedLot.id;
  }

  get modalTitle() {
    return this.selectedLot ? 'Edit Lot' : 'Add Lot';
  }

  get bidHeaders() {
    return Bid.listHeaders();
  }

  get bidOptions() {
    return Bid.defaultOptions();
  }

  get bidScope() {
    return () => Bid.includes(['user']).where({ lot: this.lotId });
  }

  get windowSize() {
    return window.outerWidth;
  }

  get selectedBid() {
    return this.selected[0] || null;
  }

  openImage(url: string) {
    if (!url) {
      return;
    }
    window.open(url, '_blank');
  }

  deleteImage(media: Media) {
    if (!media || !this.lot) {
      return;
    }

    const index = this.lot.images.indexOf(media);
    if (index !== -1) {
      this.lot.images.splice(index, 1);
      this.mediaToDelete.push(media);
    }
  }

  restoreImage(media: Media) {
    if (!media || !this.lot) {
      return;
    }

    const index = this.mediaToDelete.indexOf(media);
    if (index !== -1) {
      this.mediaToDelete.splice(index, 1);
      this.lot.images.push(media);
    }
  }

  update() {
    (this.$refs.bidTable as AbstractTable).update();
  }

  confirmClose() {
    if (
      (this.lot && (this.lot.isDirty() || this.lot.isDirty('images'))) ||
      this.mediaToDelete.length > 0
    ) {
      this.closeConfirmDialog = true;
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close-lot');
  }

  confirmDeleteBid() {
    this.bidConfirmDialog = true;
  }

  addBid(edit: boolean = false) {
    if (edit) {
      this.bidToEdit = this.selectedBid;
    } else {
      this.bidToEdit = null;
    }

    this.bidDialog = true;
  }

  async addMedia(mediaId: number) {
    if (!mediaId || !this.lot) {
      return;
    }

    try {
      const media = (await Media.find(mediaId)).data;
      this.lot.images.push(media);
    } catch (e) {
      // Not found
    }
  }

  async setWinningBid() {
    if (!this.selectedBid) {
      return;
    }

    if (this.selectedBid.won) {
      this.selectedBid.won = false;
    } else {
      this.selectedBid.won = true;
    }
    try {
      await this.selectedBid.save();
    } catch (err) {
      this.selectedBid.won = false;
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async deleteSelectedBid() {
    if (!this.selectedBid) {
      return;
    }
    try {
      await this.selectedBid.destroy();
    } catch (err) {
      // Error
    } finally {
      this.bidConfirmDialog = false;
      this.selected = [];
      this.update();
    }
  }

  async deleteMedia(media: Media) {
    if (!media) {
      return;
    }

    try {
      await media.destroy();
    } catch (e) {
      // Error
    }
  }

  async save() {
    if (!this.lot || !this.auction) {
      return;
    }

    this.lot.auction = this.auction;
    // @ts-ignore
    this.lot.salePrice = this.$parseCurrency(this.salePrice);

    if (this.mediaToDelete) {
      this.mediaToDelete.forEach(media => {
        this.deleteMedia(media);
      });
    }

    if (!this.lot.number || this.lot.number.trim() === '') {
      this.lot.number = null;
    }

    try {
      await this.lot.save({ with: ['auction.id', 'images.id'] });

      this.$emit('save-lot');
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    try {
      this.auction = (await Auction.find(this.auctionId)).data;
    } catch (err) {
      snackModule.showSnackbar('Auction not found');
    }

    if (this.selectedLot && this.selectedLot.id) {
      try {
        const scope = await Lot.includes(['images']).find(this.selectedLot.id);
        this.lot = scope.data;

        if (this.lot) {
          const formatSalePrice = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
          }).format(this.lot.salePrice);
          this.salePrice = formatSalePrice;
        }
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Probably not found');
      }
    } else {
      this.lot = new Lot();
    }
  }
}
